(function(){
  // V01 "Grid clásico" — editorial agenda widget for the hero
  // Shared palette used for appointment blocks (matches Hero Mejorado V01)
  var BLOCK_COLORS = {
    green:  '#1d8a6b', // Barros Capilares (signature)
    blue:   '#2b6ea0', // Color
    orange: '#c25a2b', // Hair Spa
    red:    '#a8321f', // Corte
    purple: '#8c4a8a', // Alisado
    teal:   '#2d7e7e', // Hidrataci\u00f3n
    navy:   '#2e3a4a'  // Asesor\u00eda
  };

  // Real schedule data exported from Square POS
  var CAL_WEEKS = [
      { label:'9–14 FEB', active:2, days:[{k:'MAR',d:'10/02'},{k:'MIÉ',d:'11/02'},{k:'JUE',d:'12/02'},{k:'VIE',d:'13/02'},{k:'SÁB',d:'14/02'}] },
      { label:'16–21 FEB', active:2, days:[{k:'MAR',d:'17/02'},{k:'MIÉ',d:'18/02'},{k:'JUE',d:'19/02'},{k:'VIE',d:'20/02'},{k:'SÁB',d:'21/02'}] },
      { label:'23–28 FEB', active:2, days:[{k:'MAR',d:'24/02'},{k:'MIÉ',d:'25/02'},{k:'JUE',d:'26/02'},{k:'VIE',d:'27/02'},{k:'SÁB',d:'28/02'}] },
      { label:'2–7 MAR', active:2, days:[{k:'MAR',d:'03/03'},{k:'MIÉ',d:'04/03'},{k:'JUE',d:'05/03'},{k:'VIE',d:'06/03'},{k:'SÁB',d:'07/03'}] },
      { label:'9–14 MAR', active:2, days:[{k:'MAR',d:'10/03'},{k:'MIÉ',d:'11/03'},{k:'JUE',d:'12/03'},{k:'VIE',d:'13/03'},{k:'SÁB',d:'14/03'}] }
    ];
  
  var CAL_SCHED = {
      0: [
        {d:0,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal'},
        {d:0,s:60,du:60,t:'11:00',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:0,s:180,du:180,t:'13:00',l:'Corte Mujer',c:'red'},
        {d:0,s:210,du:90,t:'13:30',l:'Color Completo',c:'blue',lane:1},
        {d:0,s:390,du:150,t:'16:30',l:'Barros Capilares',c:'green'},
        {d:0,s:405,du:105,t:'16:45',l:'Corte Hombre',c:'red',lane:1},
        {d:0,s:420,du:150,t:'17:00',l:'Color Raíz',c:'blue',lane:2},
        {d:0,s:420,du:45,t:'17:00',l:'Lavar + Secar',c:'teal',lane:3},
        {d:1,s:30,du:90,t:'10:30',l:'Asesoría Presencial',c:'navy'},
        {d:1,s:30,du:90,t:'10:30',l:'Color Completo',c:'blue',lane:1},
        {d:1,s:60,du:90,t:'11:00',l:'Barros Capilares',c:'green',lane:2},
        {d:1,s:75,du:135,t:'11:15',l:'Corte Mujer',c:'red',lane:3},
        {d:1,s:120,du:90,t:'12:00',l:'Asesoría Presencial',c:'navy'},
        {d:1,s:150,du:30,t:'12:30',l:'Asesoría Online',c:'navy',lane:1},
        {d:1,s:300,du:90,t:'15:00',l:'Color Raíz',c:'blue'},
        {d:1,s:300,du:60,t:'15:00',l:'Corte Mujer',c:'red',lane:1},
        {d:1,s:390,du:90,t:'16:30',l:'Color Raíz',c:'blue'},
        {d:1,s:420,du:90,t:'17:00',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:1,s:495,du:60,t:'18:15',l:'Corte Mujer',c:'red'},
        {d:1,s:510,du:60,t:'18:30',l:'Corte Mujer',c:'red',lane:1},
        {d:2,s:30,du:135,t:'10:30',l:'Corte Mujer',c:'red'},
        {d:2,s:60,du:90,t:'11:00',l:'Barros Capilares',c:'green',lane:1},
        {d:2,s:420,du:90,t:'17:00',l:'Barros Capilares',c:'green'},
        {d:2,s:480,du:90,t:'18:00',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:3,s:30,du:210,t:'10:30',l:'Asesoría Presencial',c:'navy'},
        {d:3,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:1},
        {d:3,s:30,du:30,t:'10:30',l:'Corte Hombre',c:'red',lane:2},
        {d:3,s:60,du:120,t:'11:00',l:'Corte Mujer',c:'red',lane:2},
        {d:3,s:120,du:60,t:'12:00',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:3,s:135,du:90,t:'12:15',l:'Color Completo',c:'blue',lane:3},
        {d:3,s:180,du:90,t:'13:00',l:'Barros Capilares',c:'green',lane:1},
        {d:3,s:240,du:60,t:'14:00',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:300,du:60,t:'15:00',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:345,du:90,t:'15:45',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:3,s:360,du:120,t:'16:00',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green',lane:2},
        {d:3,s:390,du:75,t:'16:30',l:'Corte Mujer',c:'red',lane:3},
        {d:3,s:420,du:150,t:'17:00',l:'Asesoría Presencial',c:'navy',lane:4},
        {d:3,s:435,du:105,t:'17:15',l:'Hair Spa Harmony',c:'orange',lane:1},
        {d:3,s:480,du:120,t:'18:00',l:'Corte Mujer',c:'red'},
        {d:3,s:495,du:90,t:'18:15',l:'Hair Spa Harmony',c:'orange',lane:2},
        {d:3,s:540,du:60,t:'19:00',l:'Color Completo',c:'blue',lane:1},
        {d:4,s:0,du:150,t:'10:00',l:'Barros Capilares',c:'green'},
        {d:4,s:0,du:150,t:'10:00',l:'Barros Capilares',c:'green',lane:1},
        {d:4,s:0,du:120,t:'10:00',l:'Corte Mujer',c:'red',lane:2},
        {d:4,s:45,du:60,t:'10:45',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:4,s:60,du:300,t:'11:00',l:'Asesoría Presencial',c:'navy',lane:4},
        {d:4,s:60,du:180,t:'11:00',l:'Corte Mujer',c:'red',lane:5},
        {d:4,s:90,du:90,t:'11:30',l:'Color Completo',c:'blue',lane:6},
        {d:4,s:120,du:60,t:'12:00',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:4,s:120,du:60,t:'12:00',l:'Corte Mujer',c:'red',lane:3},
        {d:4,s:195,du:30,t:'13:15',l:'Corte Hombre',c:'red'}
      ],
      1: [
        {d:0,s:30,du:210,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:0,s:30,du:60,t:'10:30',l:'Oxigenación',c:'orange',lane:1},
        {d:0,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:2},
        {d:0,s:60,du:90,t:'11:00',l:'Color Completo',c:'blue',lane:3},
        {d:0,s:60,du:90,t:'11:00',l:'Barros Capilares',c:'green',lane:4},
        {d:0,s:60,du:90,t:'11:00',l:'Color Completo',c:'blue',lane:5},
        {d:0,s:75,du:105,t:'11:15',l:'Color Completo',c:'blue',lane:2},
        {d:0,s:150,du:210,t:'12:30',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:300,du:90,t:'15:00',l:'Corte Mujer',c:'red'},
        {d:0,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:420,du:90,t:'17:00',l:'Hair Spa Harmony',c:'orange'},
        {d:0,s:420,du:90,t:'17:00',l:'Asesoría Presencial',c:'navy',lane:2},
        {d:0,s:450,du:90,t:'17:30',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:450,du:90,t:'17:30',l:'Color Raíz',c:'blue',lane:3},
        {d:0,s:480,du:15,t:'18:00',l:'Asesoría Presencial',c:'navy',lane:4},
        {d:0,s:510,du:60,t:'18:30',l:'Hair Spa Glow',c:'orange'},
        {d:1,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:1,s:45,du:315,t:'10:45',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:1,s:60,du:90,t:'11:00',l:'Barros Capilares',c:'green',lane:2},
        {d:1,s:105,du:90,t:'11:45',l:'Asesoría Presencial',c:'navy',lane:3},
        {d:1,s:150,du:30,t:'12:30',l:'Corte Hombre',c:'red'},
        {d:1,s:210,du:90,t:'13:30',l:'Barros Capilares',c:'green'},
        {d:1,s:240,du:90,t:'14:00',l:'Color Completo',c:'blue',lane:2},
        {d:1,s:270,du:60,t:'14:30',l:'Corte Mujer',c:'red',lane:3},
        {d:1,s:300,du:60,t:'15:00',l:'Hair Spa Glow',c:'orange'},
        {d:1,s:420,du:90,t:'17:00',l:'Barros Capilares',c:'green'},
        {d:1,s:480,du:90,t:'18:00',l:'Barros Capilares',c:'green',lane:1},
        {d:1,s:510,du:90,t:'18:30',l:'Barros Capilares',c:'green'},
        {d:1,s:510,du:60,t:'18:30',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:2,s:30,du:90,t:'10:30',l:'Hair Spa Harmony',c:'orange'},
        {d:2,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:1},
        {d:2,s:75,du:165,t:'11:15',l:'Color Completo',c:'blue',lane:1},
        {d:2,s:90,du:90,t:'11:30',l:'Hair Spa Harmony',c:'orange',lane:2},
        {d:2,s:150,du:60,t:'12:30',l:'Corte Mujer',c:'red'},
        {d:2,s:180,du:45,t:'13:00',l:'Lavar + Secar',c:'teal',lane:2},
        {d:2,s:255,du:60,t:'14:15',l:'Hair Spa Glow',c:'orange'},
        {d:2,s:300,du:300,t:'15:00',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:2,s:330,du:60,t:'15:30',l:'Hair Spa Glow',c:'orange'},
        {d:2,s:360,du:75,t:'16:00',l:'Corte Mujer',c:'red',lane:2},
        {d:2,s:390,du:30,t:'16:30',l:'Corte Hombre',c:'red'},
        {d:3,s:30,du:90,t:'10:30',l:'Corte Mujer',c:'red'},
        {d:3,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:1},
        {d:3,s:90,du:240,t:'11:30',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:3,s:120,du:60,t:'12:00',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:180,du:60,t:'13:00',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:240,du:75,t:'14:00',l:'Corte Mujer',c:'red'},
        {d:3,s:270,du:90,t:'14:30',l:'Color Raíz',c:'blue',lane:2},
        {d:3,s:285,du:60,t:'14:45',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:3,s:300,du:90,t:'15:00',l:'Color Completo',c:'blue',lane:4},
        {d:3,s:330,du:270,t:'15:30',l:'Asesoría Presencial',c:'navy'},
        {d:3,s:360,du:90,t:'16:00',l:'Color Raíz',c:'blue',lane:1},
        {d:3,s:360,du:90,t:'16:00',l:'Color Raíz',c:'blue',lane:2},
        {d:3,s:435,du:60,t:'17:15',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:3,s:450,du:150,t:'17:30',l:'Corte Mujer',c:'red',lane:1},
        {d:3,s:465,du:90,t:'17:45',l:'Asesoría Presencial',c:'navy',lane:2},
        {d:3,s:480,du:120,t:'18:00',l:'Corte Curly',c:'red',lane:4},
        {d:3,s:495,du:60,t:'18:15',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:3,s:510,du:90,t:'18:30',l:'Color Completo',c:'blue',lane:5},
        {d:3,s:525,du:45,t:'18:45',l:'Corte Mujer',c:'red',lane:6},
        {d:3,s:540,du:30,t:'19:00',l:'Corte Hombre',c:'red',lane:7},
        {d:4,s:0,du:495,t:'10:00',l:'Asesoría Presencial',c:'navy'},
        {d:4,s:0,du:165,t:'10:00',l:'Corte Curly',c:'red',lane:1},
        {d:4,s:0,du:90,t:'10:00',l:'Barros Capilares',c:'green',lane:2},
        {d:4,s:0,du:60,t:'10:00',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:4,s:30,du:210,t:'10:30',l:'Barros Capilares',c:'green',lane:4},
        {d:4,s:60,du:150,t:'11:00',l:'Color Completo',c:'blue',lane:3},
        {d:4,s:60,du:150,t:'11:00',l:'Barros Capilares',c:'green',lane:5},
        {d:4,s:60,du:45,t:'11:00',l:'Corte Mujer',c:'red',lane:6},
        {d:4,s:120,du:90,t:'12:00',l:'Hair Spa Harmony',c:'orange',lane:2},
        {d:4,s:180,du:45,t:'13:00',l:'Corte Hombre',c:'red',lane:1},
        {d:4,s:210,du:180,t:'13:30',l:'Alisado Orgánico',c:'purple',lane:2},
        {d:4,s:225,du:120,t:'13:45',l:'Hair Spa Glow',c:'orange',lane:1}
      ],
      2: [
        {d:0,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:0,s:30,du:60,t:'10:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:0,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:2},
        {d:0,s:45,du:180,t:'10:45',l:'Alisado Orgánico',c:'purple',lane:3},
        {d:0,s:60,du:150,t:'11:00',l:'Barros Capilares',c:'green',lane:4},
        {d:0,s:120,du:90,t:'12:00',l:'Color Completo',c:'blue'},
        {d:0,s:135,du:60,t:'12:15',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:0,s:255,du:90,t:'14:15',l:'Hair Spa Harmony',c:'orange'},
        {d:0,s:300,du:90,t:'15:00',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:390,du:90,t:'16:30',l:'Color Completo',c:'blue'},
        {d:0,s:450,du:90,t:'17:30',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:480,du:90,t:'18:00',l:'Hair Spa Harmony',c:'orange'},
        {d:1,s:30,du:150,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:1,s:120,du:150,t:'12:00',l:'Barros Capilares',c:'green',lane:1},
        {d:1,s:225,du:150,t:'13:45',l:'Color Raíz',c:'blue'},
        {d:1,s:240,du:90,t:'14:00',l:'Color Raíz',c:'blue',lane:2},
        {d:1,s:375,du:60,t:'16:15',l:'Hair Spa Glow',c:'orange'},
        {d:1,s:450,du:90,t:'17:30',l:'Barros Capilares',c:'green'},
        {d:1,s:480,du:60,t:'18:00',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:2,s:30,du:375,t:'10:30',l:'Color Completo',c:'blue'},
        {d:2,s:30,du:90,t:'10:30',l:'Color Completo',c:'blue',lane:1},
        {d:2,s:300,du:90,t:'15:00',l:'Hair Spa Harmony',c:'orange',lane:1},
        {d:2,s:360,du:60,t:'16:00',l:'Corte Mujer',c:'red',lane:2},
        {d:2,s:375,du:90,t:'16:15',l:'Asesoría Presencial',c:'navy',lane:3},
        {d:2,s:405,du:90,t:'16:45',l:'Barros Capilares',c:'green'},
        {d:2,s:420,du:90,t:'17:00',l:'Color Completo',c:'blue',lane:1},
        {d:2,s:480,du:90,t:'18:00',l:'Barros Capilares',c:'green',lane:2},
        {d:2,s:495,du:90,t:'18:15',l:'Hair Spa Harmony',c:'orange'},
        {d:2,s:570,du:30,t:'19:30',l:'Asesoría Presencial',c:'navy',lane:1},
        {d:3,s:30,du:120,t:'10:30',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:30,du:90,t:'10:30',l:'Color Completo',c:'blue',lane:1},
        {d:3,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:2},
        {d:3,s:30,du:30,t:'10:30',l:'Corte Hombre',c:'red',lane:3},
        {d:3,s:45,du:90,t:'10:45',l:'Color Completo',c:'blue',lane:4},
        {d:3,s:75,du:210,t:'11:15',l:'Corte Mujer',c:'red',lane:2},
        {d:3,s:75,du:90,t:'11:15',l:'Corte Curly',c:'red',lane:3},
        {d:3,s:120,du:90,t:'12:00',l:'Color Completo',c:'blue',lane:1},
        {d:3,s:120,du:90,t:'12:00',l:'Hair Spa Harmony',c:'orange',lane:5},
        {d:3,s:135,du:60,t:'12:15',l:'Corte Mujer',c:'red',lane:4},
        {d:3,s:150,du:90,t:'12:30',l:'Barros Capilares',c:'green'},
        {d:3,s:210,du:90,t:'13:30',l:'Hair Spa Harmony',c:'orange',lane:1},
        {d:3,s:270,du:60,t:'14:30',l:'Corte Mujer',c:'red'},
        {d:3,s:315,du:60,t:'15:15',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:3,s:330,du:90,t:'15:30',l:'Barros Capilares',c:'green'},
        {d:3,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green',lane:2},
        {d:3,s:390,du:60,t:'16:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:3,s:405,du:90,t:'16:45',l:'Color Raíz',c:'blue',lane:3},
        {d:3,s:420,du:90,t:'17:00',l:'Barros Capilares',c:'green'},
        {d:3,s:450,du:90,t:'17:30',l:'Color Completo',c:'blue',lane:1},
        {d:3,s:465,du:90,t:'17:45',l:'Asesoría Presencial',c:'navy',lane:2},
        {d:3,s:480,du:90,t:'18:00',l:'Corte Mujer',c:'red',lane:4},
        {d:3,s:540,du:45,t:'19:00',l:'Lavar + Secar',c:'teal'},
        {d:4,s:0,du:195,t:'10:00',l:'Corte Mujer',c:'red'},
        {d:4,s:0,du:90,t:'10:00',l:'Barros Capilares',c:'green',lane:1},
        {d:4,s:0,du:60,t:'10:00',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:4,s:90,du:60,t:'11:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:4,s:165,du:60,t:'12:45',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:4,s:195,du:30,t:'13:15',l:'Corte Hombre',c:'red'}
      ],
      3: [
        {d:0,s:30,du:90,t:'10:30',l:'Color Completo',c:'blue'},
        {d:0,s:30,du:75,t:'10:30',l:'Corte Mujer',c:'red',lane:1},
        {d:0,s:30,du:45,t:'10:30',l:'Lavar + Secar',c:'teal',lane:2},
        {d:0,s:105,du:30,t:'11:45',l:'Asesoría Online',c:'navy',lane:1},
        {d:0,s:120,du:210,t:'12:00',l:'Barros Capilares',c:'green'},
        {d:0,s:210,du:180,t:'13:30',l:'Alisado Orgánico',c:'purple',lane:1},
        {d:0,s:240,du:75,t:'14:00',l:'Corte Mujer',c:'red',lane:2},
        {d:0,s:270,du:60,t:'14:30',l:'Hair Spa Glow',c:'orange',lane:3},
        {d:0,s:285,du:90,t:'14:45',l:'Hidratación',c:'teal',lane:4},
        {d:0,s:330,du:90,t:'15:30',l:'Asesoría Presencial',c:'navy'},
        {d:0,s:345,du:60,t:'15:45',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:0,s:360,du:240,t:'16:00',l:'Alisado Orgánico',c:'purple',lane:3},
        {d:0,s:360,du:90,t:'16:00',l:'Color Raíz',c:'blue',lane:5},
        {d:0,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green',lane:6},
        {d:0,s:420,du:60,t:'17:00',l:'Hair Spa Glow',c:'orange'},
        {d:0,s:420,du:60,t:'17:00',l:'Corte Mujer',c:'red',lane:1},
        {d:0,s:450,du:60,t:'17:30',l:'Corte Mujer',c:'red',lane:2},
        {d:0,s:480,du:90,t:'18:00',l:'Color Raíz',c:'blue'},
        {d:0,s:510,du:60,t:'18:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:1,s:30,du:150,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:1,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green',lane:1},
        {d:1,s:120,du:90,t:'12:00',l:'Barros Capilares',c:'green',lane:1},
        {d:1,s:180,du:60,t:'13:00',l:'Corte Mujer',c:'red'},
        {d:1,s:300,du:300,t:'15:00',l:'Asesoría Presencial',c:'navy'},
        {d:1,s:300,du:60,t:'15:00',l:'Corte Mujer',c:'red',lane:1},
        {d:1,s:330,du:90,t:'15:30',l:'Hair Spa Harmony',c:'orange',lane:2},
        {d:1,s:450,du:90,t:'17:30',l:'Barros Capilares',c:'green',lane:1},
        {d:1,s:450,du:90,t:'17:30',l:'Asesoría Presencial',c:'navy',lane:2},
        {d:1,s:510,du:90,t:'18:30',l:'Color Raíz',c:'blue',lane:3},
        {d:1,s:510,du:60,t:'18:30',l:'Hair Spa Glow',c:'orange',lane:4},
        {d:2,s:60,du:90,t:'11:00',l:'Color Completo',c:'blue'},
        {d:2,s:60,du:90,t:'11:00',l:'Color Completo',c:'blue',lane:1},
        {d:2,s:60,du:90,t:'11:00',l:'Barros Capilares',c:'green',lane:2},
        {d:2,s:60,du:60,t:'11:00',l:'Corte Mujer',c:'red',lane:3},
        {d:2,s:90,du:90,t:'11:30',l:'Barros Capilares',c:'green',lane:4},
        {d:2,s:120,du:90,t:'12:00',l:'Color Completo',c:'blue',lane:3},
        {d:2,s:120,du:60,t:'12:00',l:'Oxigenación',c:'orange',lane:5},
        {d:2,s:210,du:90,t:'13:30',l:'Color Raíz',c:'blue'},
        {d:2,s:240,du:30,t:'14:00',l:'Corte Hombre',c:'red',lane:1},
        {d:2,s:495,du:30,t:'18:15',l:'Corte Hombre',c:'red'},
        {d:2,s:540,du:30,t:'19:00',l:'Asesoría Online',c:'navy'},
        {d:3,s:30,du:60,t:'10:30',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:30,du:60,t:'10:30',l:'Corte Mujer',c:'red',lane:1},
        {d:3,s:90,du:90,t:'11:30',l:'Hair Spa Harmony',c:'orange'},
        {d:3,s:120,du:90,t:'12:00',l:'Barros Capilares',c:'green',lane:1},
        {d:3,s:195,du:60,t:'13:15',l:'Hair Spa Glow',c:'orange'},
        {d:3,s:240,du:90,t:'14:00',l:'Color Completo',c:'blue',lane:1},
        {d:3,s:285,du:75,t:'14:45',l:'Corte Mujer',c:'red'},
        {d:3,s:300,du:90,t:'15:00',l:'Asesoría Presencial',c:'navy',lane:2},
        {d:3,s:330,du:60,t:'15:30',l:'Oxigenación',c:'orange',lane:1},
        {d:3,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green'},
        {d:3,s:360,du:90,t:'16:00',l:'Barros Capilares',c:'green',lane:3},
        {d:3,s:390,du:60,t:'16:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:3,s:420,du:150,t:'17:00',l:'Barros Capilares',c:'green',lane:2},
        {d:3,s:420,du:90,t:'17:00',l:'Color Completo',c:'blue',lane:4},
        {d:3,s:465,du:60,t:'17:45',l:'Corte Mujer',c:'red'},
        {d:3,s:495,du:90,t:'18:15',l:'Corte Curly',c:'red',lane:1},
        {d:3,s:495,du:90,t:'18:15',l:'Hair Spa Harmony',c:'orange',lane:3},
        {d:4,s:0,du:90,t:'10:00',l:'Color Completo',c:'blue'},
        {d:4,s:60,du:60,t:'11:00',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:4,s:120,du:90,t:'12:00',l:'Asesoría Presencial',c:'navy'},
        {d:4,s:180,du:60,t:'13:00',l:'Hair Spa Glow',c:'orange',lane:1}
      ],
      4: [
        {d:0,s:210,du:90,t:'13:30',l:'Barros Capilares',c:'green'},
        {d:0,s:360,du:90,t:'16:00',l:'Color Completo',c:'blue'},
        {d:0,s:420,du:90,t:'17:00',l:'Barros Capilares',c:'green',lane:1},
        {d:0,s:450,du:90,t:'17:30',l:'Color Completo',c:'blue'},
        {d:0,s:450,du:90,t:'17:30',l:'Barros Capilares',c:'green',lane:2},
        {d:0,s:465,du:105,t:'17:45',l:'Corte Mujer',c:'red',lane:3},
        {d:0,s:480,du:90,t:'18:00',l:'Color Raíz',c:'blue',lane:4},
        {d:1,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:1,s:300,du:180,t:'15:00',l:'Alisado Orgánico',c:'purple'},
        {d:1,s:420,du:90,t:'17:00',l:'Color Completo',c:'blue',lane:1},
        {d:2,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:2,s:90,du:180,t:'11:30',l:'Color Raíz',c:'blue',lane:1},
        {d:2,s:90,du:90,t:'11:30',l:'Hair Spa Harmony',c:'orange',lane:2},
        {d:2,s:195,du:60,t:'13:15',l:'Hair Spa Glow',c:'orange'},
        {d:2,s:360,du:90,t:'16:00',l:'Color Raíz',c:'blue'},
        {d:2,s:390,du:90,t:'16:30',l:'Barros Capilares',c:'green',lane:1},
        {d:2,s:420,du:90,t:'17:00',l:'Barros Capilares',c:'green',lane:2},
        {d:3,s:30,du:150,t:'10:30',l:'Barros Capilares',c:'green'},
        {d:3,s:90,du:60,t:'11:30',l:'Hair Spa Glow',c:'orange',lane:1},
        {d:3,s:165,du:60,t:'12:45',l:'Corte Mujer',c:'red',lane:1},
        {d:3,s:180,du:150,t:'13:00',l:'Color Completo',c:'blue'},
        {d:3,s:360,du:90,t:'16:00',l:'Hair Spa Harmony',c:'orange'},
        {d:3,s:435,du:90,t:'17:15',l:'Barros Capilares',c:'green',lane:1},
        {d:3,s:495,du:90,t:'18:15',l:'Hair Spa Harmony',c:'orange'},
        {d:4,s:0,du:60,t:'10:00',l:'Corte Mujer',c:'red'},
        {d:4,s:30,du:90,t:'10:30',l:'Barros Capilares',c:'green',lane:1},
        {d:4,s:30,du:60,t:'10:30',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:4,s:60,du:150,t:'11:00',l:'Color Completo',c:'blue'},
        {d:4,s:105,du:60,t:'11:45',l:'Hair Spa Glow',c:'orange',lane:2},
        {d:4,s:150,du:90,t:'12:30',l:'Color Raíz',c:'blue',lane:1}
      ]
    };


  var activeWeek = 2; // default: S3 23-28 feb (featured)
  var activeDay  = CAL_WEEKS[activeWeek].active; // mobile list view: which day is shown

  function renderDayTabs(){
    var tabsEl = document.getElementById('v1DayTabs');
    if (!tabsEl) return;
    var wk = CAL_WEEKS[activeWeek];
    var html = '';
    wk.days.forEach(function(day, di){
      html += '<button type="button" class="hero__lc-daytab'
           + (di === activeDay ? ' is-active' : '')
           + '" data-day="' + di + '" role="tab" aria-selected="' + (di === activeDay) + '">'
           +   '<span class="hero__lc-daytab-k">' + day.k + '</span>'
           +   '<span class="hero__lc-daytab-d">' + day.d + '</span>'
           + '</button>';
    });
    tabsEl.innerHTML = html;
    tabsEl.querySelectorAll('.hero__lc-daytab').forEach(function(btn){
      btn.addEventListener('click', function(){
        var di = parseInt(btn.getAttribute('data-day'), 10);
        if (isNaN(di) || di === activeDay) return;
        activeDay = di;
        closePopover();
        renderDayTabs();
        renderDayList();
      });
    });
  }

  function renderDayList(){
    var listEl = document.getElementById('v1DayList');
    if (!listEl) return;
    var sched = CAL_SCHED[activeWeek] || [];
    var items = sched.filter(function(e){ return e.d === activeDay; })
                     .slice()
                     .sort(function(a, b){ return a.s - b.s; });
    var html = '';
    if (items.length === 0){
      html = '<div class="hero__lc-dayempty">Sin citas este d\u00eda</div>';
    } else {
      items.forEach(function(e, i){
        var color = BLOCK_COLORS[e.c] || '#555';
        html += '<button type="button" class="hero__lc-dayrow" data-idx="' + i + '">'
             +    '<span class="hero__lc-dayrow-time">' + e.t + '</span>'
             +    '<i class="hero__lc-dayrow-dot" style="background:' + color + '"></i>'
             +    '<span class="hero__lc-dayrow-svc">' + e.l + '</span>'
             +    '<span class="hero__lc-dayrow-dur">' + e.du + ' min</span>'
             + '</button>';
      });
    }
    listEl.innerHTML = html;
  }

  function renderCalendar(){
    var grid = document.getElementById('v1Grid');
    if(!grid) return;
    var wk = CAL_WEEKS[activeWeek];
    var sched = CAL_SCHED[activeWeek] || [];
    var hours = ['10','11','12','13','14','15','16','17','18','19'];

    var html = '<div class="hero__lc-timecol">';
    for (var i = 0; i < hours.length; i++) {
      html += '<div class="hero__lc-tlbl">' + hours[i] + 'h</div>';
    }
    html += '</div>';

    for (var di = 0; di < 5; di++) {
      var day = wk.days[di];
      var isActive = (di === wk.active);
      html += '<div class="hero__lc-daycol' + (isActive ? ' is-active' : '') + '" data-day="' + di + '">'
           +    '<div class="hero__lc-dhd">' + day.k + '</div>'
           + '</div>';
    }
    grid.innerHTML = html;

    var totalMinutes = 600; // 10:00 -> 20:00
    var headerPct = 12;     // top % reserved for the sticky day header

    // Compute lane count per (day, time cluster) for overlap handling
    function laneCount(e){
      var maxLane = e.lane || 0;
      for (var j = 0; j < sched.length; j++){
        var x = sched[j];
        if (x.d === e.d && Math.abs(x.s - e.s) < 35){
          if ((x.lane || 0) > maxLane) maxLane = x.lane || 0;
        }
      }
      return maxLane + 1;
    }

    sched.forEach(function(e){
      var col = grid.querySelector('.hero__lc-daycol[data-day="' + e.d + '"]');
      if(!col) return;
      var blk = document.createElement('div');
      blk.className = 'hero__lc-blk';
      blk.style.background = BLOCK_COLORS[e.c] || '#555';
      var topPct = headerPct + ((e.s / totalMinutes) * (100 - headerPct));
      var hPct   = (e.du / totalMinutes) * (100 - headerPct);
      blk.style.top = topPct + '%';
      blk.style.height = Math.max(hPct, 3) + '%';
      var lanes = laneCount(e);
      var lane = e.lane || 0;
      var w = 100 / lanes;
      blk.style.left = 'calc(' + (lane * w) + '% + 2px)';
      blk.style.width = 'calc(' + w + '% - 4px)';
      blk.innerHTML = '<small>' + e.t + '</small>' + e.l;
      col.appendChild(blk);
    });

    var lbl = document.getElementById('v1WkLabel');
    if (lbl) lbl.textContent = wk.label;
  }

  function fmtEnd(e){
    var endMin = e.s + e.du;
    var endH = Math.floor(endMin / 60) + 10;
    var endM = (endMin % 60).toString();
    if (endM.length === 1) endM = '0' + endM;
    return endH + ':' + endM;
  }

  function closePopover(){
    var p = document.getElementById('v1Popover');
    if (p) p.remove();
  }

  function showPopover(entry, anchor){
    closePopover();
    var host = document.querySelector('.hero__livecal');
    if (!host) return;
    var pop = document.createElement('div');
    pop.className = 'hero__lc-popover';
    pop.id = 'v1Popover';
    pop.innerHTML =
      '<div class="hero__lc-ptop"><span>Cita recurrente</span><button type="button" class="hero__lc-pclose" aria-label="Cerrar">\u00d7</button></div>'
      + '<h5 class="hero__lc-ptitle">' + entry.l + '</h5>'
      + '<div class="hero__lc-ptime">' + entry.t + ' \u2192 ' + fmtEnd(entry) + ' \u00b7 ciclo de 4 semanas</div>'
      + '<a href="#pricing" class="hero__lc-pbook" data-mmp-scroll>Reservar hora similar \u2192</a>';

    var hRect = host.getBoundingClientRect();
    var aRect = anchor.getBoundingClientRect();
    var left = aRect.left - hRect.left + aRect.width + 8;
    var top  = aRect.top  - hRect.top;
    var maxLeft = hRect.width - 272;
    if (left > maxLeft) left = aRect.left - hRect.left - 268;
    if (left < 8) left = 8;
    if (top > hRect.height - 160) top = hRect.height - 170;
    if (top < 8) top = 8;
    pop.style.left = left + 'px';
    pop.style.top  = top  + 'px';

    host.appendChild(pop);
    pop.querySelector('.hero__lc-pclose').addEventListener('click', closePopover);
  }

  document.addEventListener('click', function(ev){
    if (!ev.target.closest('.hero__lc-blk')
        && !ev.target.closest('.hero__lc-dayrow')
        && !ev.target.closest('.hero__lc-popover')) closePopover();
  });

  function bindWeeks(){
    var wrap = document.getElementById('v1Weeks');
    if (!wrap) return;
    var btns = wrap.querySelectorAll('.hero__lc-wbtn');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var idx = parseInt(b.getAttribute('data-w'), 10);
        if (isNaN(idx) || idx === activeWeek) return;
        activeWeek = idx;
        activeDay  = CAL_WEEKS[activeWeek].active; // reset to featured day of new week
        btns.forEach(function(x){ x.classList.toggle('is-on', x === b); });
        closePopover();
        renderDayTabs();
        renderDayList();
        var grid = document.getElementById('v1Grid');
        if (grid){
          grid.style.opacity = '0';
          grid.style.transform = 'translateY(6px)';
          setTimeout(function(){
            renderCalendar();
            requestAnimationFrame(function(){
              grid.style.opacity = '1';
              grid.style.transform = 'translateY(0)';
            });
          }, 160);
        } else {
          renderCalendar();
        }
      });
    });
  }

  function init(){
    bindWeeks();
    renderDayTabs();
    renderDayList();
    renderCalendar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
